import { useTwoRailsExperimentStatus } from '../hooks/useTwoRailsExperimentStatus';
import { ConversionBarTwoRailsShell } from '../shared/ConversionBarTwoRailsShell';
import { useExternalTicketsHeadline } from './hooks/useExternalTicketsHeadline';
import { ExternalTicketsPanelCta } from './ExternalTicketsPanelCta';
import { ExternalTicketsPanelDate } from './ExternalTicketsPanelDate';
import { ExternalTicketsPanelHeadline } from './ExternalTicketsPanelHeadline';
import { ExternalTicketsTwoRailsPanel } from './ExternalTicketsTwoRailsPanel';
import styles from './ExternalTicketsPanel.module.scss';

export const ExternalTicketsPanel: React.FC = () => {
  const { isExternalTicketingInformationAvailable } = useExternalTicketsHeadline();
  const experimentStatus = useTwoRailsExperimentStatus();

  if (!isExternalTicketingInformationAvailable) {
    return null;
  }

  return (
    <ConversionBarTwoRailsShell
      experimentStatus={experimentStatus}
      containerTestId="external-tickets-panel"
      defaultPanelClassName={styles.container}
      defaultPanelTestId="external-tickets-panel-default"
      twoRailsTestId="external-tickets-panel-two-rails-experiment"
      defaultPanel={
        <>
          <div className={styles.content}>
            <ExternalTicketsPanelHeadline />
            <ExternalTicketsPanelDate />
          </div>
          <ExternalTicketsPanelCta />
        </>
      }
      twoRailsPanel={<ExternalTicketsTwoRailsPanel />}
    />
  );
};
